import request from '../utils/request';

/**获取公益&活动列表 */
export async function getProList (params) {
  return request.post('GetFundProjectList',params);
}
/**获取公益项目详情 */
export async function getProDetail (params) {
  return request.get('GetProjectDetailInfo',{params: params});
}

/**获取公益活动详情 */
export async function getActDetail (params) {
  return request.get('GetFundActivityModel',{params: params});
}

/**获取公益动态列表 */
export async function getNewList (params) {
  return request.get('GetNewsList',{params: params});
}
/**获取公益动态详情 */
export async function getNewDetail (params) {
  return request.get('GetNews',{params: params});
}